/* @flow */
import type { RouterStore } from 'mobx-react-router';

import { formulateUri } from 'tables/components/ReportView/state';
import type { ReportViewState } from 'tables/components/ReportView/state';

class NavigationService {
  routerStore: RouterStore;

  init(store: RouterStore) {
    this.routerStore = store;
  }

  goBack() {
    if (!this.routerStore) {
      return;
    }

    this.routerStore.goBack();
  }

  go(steps: number) {
    this.routerStore && this.routerStore.go(steps);
  }

  replace(route: string, state: Object) {
    this.routerStore && this.routerStore.replace(route, state);
  }

  navigateTo(route: string, state?: Object) {
    this.routerStore && this.routerStore.push(route, state);
  }

  navigateToReportView(tablePath: string, reportViewState: ReportViewState) {
    this.navigateTo(formulateUri(tablePath, reportViewState));
  }

  formulateReportViewUri = formulateUri;
}

const service = new NavigationService();

export default service;
